module.exports = __webpack_public_path__ + "static/media/photography-2-4.ebf82823.jpg";